import { graphql } from "gatsby";
import { SpinnersBasic } from "../../../../src/examples/components/Spinners";
import * as React from 'react';
export default {
  graphql,
  SpinnersBasic,
  React
};